import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CreateQuestionTypes } from './model';

export const useSubmitQuestion = (): UseMutationResult<
    CreateQuestionTypes,
    unknown,
    CreateQuestionTypes
> =>
    useBffPostMutation<CreateQuestionTypes, CreateQuestionTypes>(
        '/turn-to/questions',
        [],
        [BffQueryKey.TURN_TO_DATA],
    );
